<template>
  <u-menu right>
    <template #activator="{toggle}">
      <u-button text variant="secondary" @click="toggle">
        {{ profile.surname }} {{ profile.name }}

        <div class="w-7 h-7 inline-flex rounded-full bg-purple-500 ml-2">
          <span class="m-auto text-sm font-medium text-white">
            {{ profile.surname[0] }}{{ profile.name[0] }}
          </span>
        </div>
      </u-button>
    </template>

    <u-card>
      <u-list>
        <p class="px-4 mt-2 mb-2 text-gray-400 text-xs font-medium uppercase">
          {{ profile.surname }} {{ profile.name }}
        </p>

        <logout-dialog />
      </u-list>
    </u-card>
  </u-menu>
</template>

<script>
import LogoutDialog from "@/app/shared/new-component/LogoutDialog";

export default {
  name: "UserProfile",
  components: { LogoutDialog },
  data() {
    return {
      profile: {
        surname: "Учитель",
        name: "Школы"
      }
    };
  },

  watch: {
    $route: {
      // immediate: шапка с профилем монтируется уже после ухода с формы входа,
      // а профиль к этому моменту записан (Login.vue пишет его до перехода,
      // App.vue — до того, как покажет рабочие экраны). Без immediate до первого
      // перехода висит заглушка «Учитель Школы».
      immediate: true,

      handler() {
        const stored = sessionStorage.getItem("profile");

        // JSON.parse(null) возвращает null и ломает шаблон — пустую запись
        // просто игнорируем, оставляя то, что уже показано.
        if (!stored) return;

        try {
          this.profile = JSON.parse(stored) || this.profile;
        } catch {
          //  pass
        }
      }
    }
  }
};
</script>
